import SvgIconDowload from '../@svg/SvgDowload';
import './index.scss';
import { Button, ButtonProps } from 'antd';

const DowloadButton = (props: ButtonProps) => {
  return (
    <Button className={`download-button ${props.className}`} {...props}>
      <SvgIconDowload />
      <span>エクスポート</span>
    </Button>
  );
};

export default DowloadButton;
